export const isLoadingSelector = state => state.createPost.get('isLoading');
export const isUploadingSelector = state => state.createPost.get('isUploading');
export const formErrorsSelector = state => state.createPost.get('errors');
export const uploadedPercentSelector = state => state.createPost.get('uploadedPercent');
